export const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-40%',
        transform: 'translate(-50%, -50%)',
        padding: "0px",
        minWidth: "350px",
        maxWidth: "500px",
        width: "90%",
        borderRadius: "20px"
    },
};

export const headerContainerStyle = {
    background: "linear-gradient(88deg, #F7BD08 0%, #A94F20 63.11%, #3A182F 82.51%, #1B1926 100%)",
    height: "55px",
    paddingTop: "8px",
}

export const iconStyle = {
    float: "right",
    color: "white",
    marginTop: "5px",
    marginRight: "10px",
}

export const titleStyle = {
    textAlign: "center",
    fontWeight: "500",
    fontSize: "18px",
    marginTop: "30px"
}

export const textStyle = {
    marginTop: "10px",
    textAlign: "center",
    // fontWeight: "500",
    fontSize: "13px",
}